import { render, staticRenderFns } from "./ReporteSaldos.vue?vue&type=template&id=c8a746f6"
import script from "./ReporteSaldos.vue?vue&type=script&lang=js"
export * from "./ReporteSaldos.vue?vue&type=script&lang=js"
import style0 from "./ReporteSaldos.vue?vue&type=style&index=0&id=c8a746f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports